const MAX_SCRAMBLE_PERCENT = 0.2
const MIN_SCRAMBLE_PERCENT = 0.05
import {GetRandomChar, ReplaceChar} from './text-utility'
import RandomUtils from '@/scripts/utils/random'

export function Scramble (text, minPercent, maxPercent) {
  let minP = minPercent || MIN_SCRAMBLE_PERCENT
  let maxP = maxPercent || MAX_SCRAMBLE_PERCENT
  let scramblePercent = RandomUtils.RandomNumber(minP, maxP)
  let scrambledIndices = new Set()
  let scrambleAmount = Math.floor(text.length * scramblePercent)
  for (let i = 0; i< scrambleAmount;i++) {
    // gets a unique random index
    let index= 0
    do {
      index = RandomUtils.RandomNumber(0, text.length -1)
    } while (scrambledIndices.has(index))
    scrambledIndices.add(index)
    text = ReplaceChar(text,index, GetRandomChar())
  }
  return text
}